import { RentalFile } from "./rental-file";

export type RentalCandidate = {
    id: number;
    firstName: string;
    lastName: string;
    email: string;
    dateOfBirth: Date;
    rentalFiles: RentalFile[];
  }
  

export enum InvitedSource {
    IMMOWEB = 'immoweb',
    YALLY_APPARTMENTS = 'yally.apartments',
}